<script lang="ts">
  import Link from "../../organisms/settings/Link.svelte";
</script>

<div class="flex">
  <div class="flex-1 mr-8">
    <Link />
  </div>
</div>
